import React from 'react';
import Header from '../components/header'
import Footer from '../components/footer';
import './contactsPage.css';
import { useState } from 'react';
import { VerticalSeparator, LineSeparator } from '../components/separators';
import { Container, Card, Form, Button, Toast } from 'react-bootstrap';
import { useEffect } from 'react';
import { ReactComponent as GeoIcon } from '../icons/geo_color.svg';
import { ReactComponent as PhoneIcon } from '../icons/telephone_color.svg';
import { ReactComponent as MailIcon } from '../icons/mail_color.svg';
import { ReactComponent as BookingIcon } from '../icons/booking_logo.svg';
import emailjs from '@emailjs/browser';

const ContactsPage = (props) => {

  const { selectedLanguage, handleLanguageChange } = props;
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_6aqtirm', 'template_sldufo7', e.target, {
        publicKey: '88Vcsp-bPEWfzD-QD',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          setShowToast(true); // Visualizza il toast di conferma
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
    e.target.reset();
  };

  return (
    <>
      <Header selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />
      <Container className="container" style={{ alignItems: 'center', textAlign: 'center' }}>
        <h1 className='text-h-contactspage-class'>{selectedLanguage === 'ita' ? "I nostri contatti" : "Our contacts"}</h1>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <p className='text-p-contactspage-class' style={{ marginLeft: '10px', marginRight: '10px' }}>
          {selectedLanguage === 'ita' ? "Chiamaci o scrivici se sei interessato a prenotare la tua vacanza in una delle nostre case." : "Call us or write to us if you are interested in booking your vacation in one of our homes."}
          <br />
          <br />
          {selectedLanguage === 'ita' ? "Se preferisci scriverci indica il periodo e il numero di ospiti. Ti risponderemo prima possibile." : "If you prefer to write to us, please indicate the dates and the number of guests. We will respond to you as soon as possible."}
        </p>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <div style={{ marginBottom: '10px' }}>
          <MailIcon className='text-i-contactspage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
          <span className='text-sh-contactspage-class'>Email:</span>
          <span className='text-sp-contactspage-class' style={{ marginLeft: '10px' }} >vacanzasantabarbara@gmail.com</span>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <PhoneIcon className='text-i-contactspage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
          <span className='text-sh-contactspage-class'>{selectedLanguage === 'ita' ? "Telefono:" : "Phone:"}</span>
          <span className='text-sp-contactspage-class' style={{ marginLeft: '10px' }}>+39 3337813274</span>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <GeoIcon className='text-i-contactspage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
          <span className='text-sh-contactspage-class'>{selectedLanguage === 'ita' ? "Indirizzo:" : "Address:"}</span>
          <span className='text-sp-contactspage-class' style={{ marginLeft: '10px' }}>Via Milano 8, Marina di Ragusa, RG</span>
        </div>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <p className='text-p-contactspage-class' style={{ marginLeft: '10px', marginRight: '10px' }}>
          {selectedLanguage === 'ita' ? "Puoi trovarci anche su:" : "You can also find us on:"}
        </p>
        <div>
          <a href="https://www.booking.com/hotel/it/casa-santabarbara.it.html" target="_blank" rel="noopener noreferrer">
            <BookingIcon className='icon-class' />
          </a>
        </div>
      </Container>
      <LineSeparator></LineSeparator>
      <Container fluid='true' style={{ maxWidth: '85%', margin: 'auto' }}>
        <Card fluid='true' style={{ backgroundColor: '#e0e0e0' }}>
          <Card.Body>
            <Card.Title style={{ textAlign: 'center' }}>{selectedLanguage === 'ita' ? "Contattaci" : "Get in touch"}</Card.Title>
            <VerticalSeparator height={"2vw"}></VerticalSeparator>
            <Form className='form' onSubmit={sendEmail}>
              <Form.Group controlId='formBasicName' className='w-100'>
                <Form.Control type='text' placeholder={selectedLanguage === 'ita' ? "Nome completo" : "Full name"} name='user_name' required />
              </Form.Group>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
              <Form.Group controlId='formBasicEmail' className='w-100'>
                <Form.Control type='email' placeholder='Email' name='user_email' required />
              </Form.Group>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
              <Form.Group controlId='formBasicSubject' className='w-100'>
                <Form.Control type='text' placeholder={selectedLanguage === 'ita' ? "Oggetto" : "Subject"} name='oggetto' required />
              </Form.Group>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
              <Form.Group controlId='formBasicMessage' className='w-100'>
                <Form.Control as='textarea' rows={8} placeholder={selectedLanguage === 'ita' ? "Messaggio" : "Message"} name='message' required />
              </Form.Group>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
              <Button variant='primary' type='submit'>{selectedLanguage === 'ita' ? "Manda Email" : "Send Email"}</Button>
            </Form>

            {/* Toast per la conferma */}
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ marginTop: '10px' }}>
              <Toast.Body style={{ backgroundColor: 'green', color: 'white' }}>Messaggio inviato!</Toast.Body>
            </Toast>

          </Card.Body>
        </Card>
      </Container>
      <VerticalSeparator height={"2vw"}></VerticalSeparator>
      <Footer />
    </>
  );
}

export default ContactsPage;
